export const iconFontAwesomeHumanitarianTentArrowsDown = (
	<i className="fa-solid fa-tent-arrows-down"></i>
);
